import React from 'react'
import { Link } from 'react-router-dom'

export default function TrainingOperation({ data }) {
    return (
        <section className="tranining-operation">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-12 col-lg-9">
                        <div className="operation-text">
                            <span className="gradient-color">  {data?.subtitle} </span>
                            <h2 className="heading heading-gap">
                                {data?.headingLine1} <br />
                                {data?.headingLine2}
                            </h2>
                            <p>{data?.description}</p>
                            <div className="operation-btn">
                                <Link className="default-btn" to={data?.buttonLink || "/"}>
                                    <span>{data?.buttonText}</span>
                                </Link>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}